import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import {environment} from '../../environments/environment';

export const InterceptorSkipHeader = 'notInterceptor';

@Injectable()
export class AuthHttpInterceptor implements HttpInterceptor {

  isNot: boolean = true;

  constructor(private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token: string = localStorage.getItem('token_id');

    //saltea el agregado del token
    if (req.headers.has(InterceptorSkipHeader)) {
      const headers = req.headers.delete(InterceptorSkipHeader);
      this.isNot = false;

      req = req.clone({
        url: req.url,
        headers: headers
      });
    }

    let validService = req.url.search(environment.url_host_permissions);
    let validServiceS3 = req.url.search(environment.url_host_ms_s3);
    let validServiceMsUser = req.url.search(environment.url_host_ms_user);

    if (token && this.isNot && validService == -1 && validServiceS3 == -1 && validServiceMsUser == -1) {
      req = req.clone({
        url: req.url.concat('?token=' + token)
      });
    } else if((validService != -1 || validServiceS3 != -1 || validServiceMsUser != -1) && token != null) {
      req = req.clone({
        headers: req.headers.set("Authorization", "Bearer " + token)
      });
    }

    // if (!req.headers.has('Content-Type')) {
    //   req = req.clone({
    //     headers: req.headers.set('Content-Type', 'application/json')
    //   });
    // }
    if (!req.headers.has('Accept')) {
      req = req.clone({
        headers: req.headers.set('Accept', 'application/json')
      });
    }

    if (req.headers.get('Content-Type') === 'multipart/form-data;') {
      req = req.clone({
        headers: req.headers.delete('Content-Type')
      })
    }

    return next.handle(req).pipe(
      tap(() => {
        // success
      }, (err: any) => {
        // error
        console.log(err);
        if (err instanceof HttpErrorResponse) {
          let error = err.error;

          if (typeof err.error === 'string') {
            error = JSON.parse(err.error);
          }
          // status 0 tambien ocurre por errores de red transitorios (ej: ráfagas de requests); solo es logout real si no hay token
          if (err.status === 0 && !token) {
            // redirect user to login
            this.router.navigate(['/autentificacion/login']);
          }

        }
      })
    );


  }
}

